import * as React from 'react';
import {
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS,
  VSI_AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT,
} from '@src/utils/aiAlerts/mapping';
import { Button, Tooltip } from 'antd';
import { TitleWrapper } from '../SensitivityControl/styled';
import { isAppModule, isEiModule } from '@src/utils/constants';
import AdminOnly from '@src/components/common/AdminOnly';
import { CustomDimensionInfo } from '@src/pages/AIAlertCohorts/styled';
import { configuredDimensionCount } from '@src/components/ai-cohorts/utils';
import ConfigChangeLogs from '@src/components/ai-cohorts/ConfigChangelogs';
import { HeaderWrapper, StyledDivider, StyledInfoIcon } from './styled';
import { useFeature } from '@src/globalStore/featureStore';
import featureNames from '@src/utils/featureToggle/constants';

interface AICohortHeaderProps {
  selectedProduct: string;
  data: any;
}

const AICohortHeader: React.FC<AICohortHeaderProps> = ({ selectedProduct, data }) => {
  const aiAlertsCustomDimensionsUpperLimitFF = useFeature(
    featureNames.AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT,
  );
  const vsiAIAlertsCustomDimensionsUpperLimit =
    aiAlertsCustomDimensionsUpperLimitFF + VSI_AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT;
  const dpiAIAlertsCustomDimensionsPerMetricLimit = useFeature(
    featureNames.DPI_AI_ALERTS_CUSTOM_DIMENSIONS_PER_METRIC_LIMIT,
  );
  const maxCount: number = isAppModule
    ? dpiAIAlertsCustomDimensionsPerMetricLimit
    : vsiAIAlertsCustomDimensionsUpperLimit;

  // Get product display name
  const getProductDisplayName = (product: string) => {
    if (isAppModule) {
      return 'App';
    }

    const productOption = AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS.find(
      (option) => option.value === product,
    );
    return productOption?.label || product;
  };

  const { aiAlertsConfig = [] } = data;
  const currentConfiguredDimensionCount = configuredDimensionCount(aiAlertsConfig);
  const [showLog, setShowLog] = React.useState(false);

  const isValidMaxCount = !!maxCount && !Array.isArray(maxCount);

  return (
    <HeaderWrapper>
      <div>
        <span>{getProductDisplayName(selectedProduct)}</span>
        <StyledDivider type="vertical" />
        <TitleWrapper>
          AI Cohorts
          <Tooltip
            placement="topLeft"
            title="AI Cohorts shows the real-time data for number of combinations being scanned by AI Alerts and refreshes every 5 minutes."
          >
            <StyledInfoIcon />
          </Tooltip>
          <AdminOnly />
          {isValidMaxCount && (
            <CustomDimensionInfo>
              Total Dimension{currentConfiguredDimensionCount < 2 ? '' : 's'} configured:{' '}
              {currentConfiguredDimensionCount} (Limit: {maxCount})
            </CustomDimensionInfo>
          )}
        </TitleWrapper>
      </div>

      <span>
        {isEiModule && (
          <Button
            style={{ marginLeft: '8px' }}
            onClick={() => {
              setShowLog(true);
            }}
          >
            Change Log
          </Button>
        )}
        {showLog && (
          <ConfigChangeLogs
            isOpen={showLog}
            toggleOpen={() => {
              setShowLog(false);
            }}
          />
        )}
      </span>
    </HeaderWrapper>
  );
};

export default AICohortHeader;
